<div class="mt-5">
    <p class="pathErrMsg">Server Down !!!</p>
</div>
